import { ApplyOnlineOptionsConst } from "@/src/constants/apply-online";
import ArrowSelect from "@/src/svg/ArrowSelect";
import { IFormApplicationProps } from "@/src/types/IApplyOnline";
import { FC } from "react";

const FormApplicationDopInfo: FC<IFormApplicationProps & { handleFocus?: () => void }> = ({
  register,
  control,
  errors,
  handleFocus,
}) => {
  return (
    <div className="form-application-additional-info">
      <div className="form-application-header">
        <h1 className="form-application-header-title">Дополнительная информация</h1>
      </div>
      <div className="form-application-body">
        <input
          className="form-application-body-input birthDate"
          type="date"
          placeholder="Дата рождения"
          onFocus={handleFocus}
          {...register("birthDate")}
        />
        <div className="form-application-body-select nationality">
          <select
            className="form-application-body-input select"
            defaultValue=""
            onFocus={handleFocus}
            {...register("nationality")}
          >
            {ApplyOnlineOptionsConst.nationality.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelect />
        </div>
        <div className="form-application-body-select country">
          <select
            className="form-application-body-input select"
            defaultValue=""
            onFocus={handleFocus}
            {...register("country")}
          >
            {ApplyOnlineOptionsConst.country.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelect />
        </div>
        <input
          className="form-application-body-input address"
          type="text"
          placeholder="Адрес"
          onFocus={handleFocus}
          {...register("address")}
        />
      </div>
    </div>
  );
};

export default FormApplicationDopInfo;
